import dayjs from 'dayjs';
import { REPORT_RANGE } from '@consts/reports';
import { parseDate } from './dates';

export const styleTime = (date: string | number) => {
    const dateDayjs = dayjs(date);
    return dateDayjs.isValid() ? dateDayjs.format('hh:mma, MM/DD/YYYY') : date;
};

export const styleDate = (format: REPORT_RANGE) => (date: string | number) => {
    const dayjsDate = parseDate(date as string, format);

    switch (format) {
        case REPORT_RANGE.QUARTERLY: {
            const [quarterYear, quarter] = (date as string).split('-');
            return `${quarterYear} - Q${parseInt(quarter)}`;
        }
        case REPORT_RANGE.WEEKLY: {
            const start = dayjsDate.clone().day(0);
            const end = dayjsDate.clone().day(6);
            return `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`;
        }
        case REPORT_RANGE.MONTHLY:
            return dayjsDate.format('YYYY-MM');
        case REPORT_RANGE.DAILY:
            return dayjsDate.format('YYYY-MM-DD');
        case REPORT_RANGE.YEARLY:
            return dayjsDate.format('YYYY');
        default:
            return dayjsDate.format('MM/DD/YYYY');
    }
};

export const styleDateRange = (dates: string[]) => {
    return dates
        .map((date: string) => {
            const dateDayjs = dayjs(date);
            return dateDayjs.format('MM/DD/YYYY');
        })
        .join(' - ');
};

/**
 * Formats large numbers with commas
 */
export const styleNumber = (value: number | string) => {
    const isNumber = typeof value === 'number';
    return isNumber ? value.toLocaleString('en-us') : value;
};
